import React from 'react';
import cx from 'classnames';

import type { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';
import { DateRange } from './DateRange';
import { isDigitalGreetingCard } from '../utils/digitalGreetingCards';

import styles from './cartItemAttributes.module.less';

/* sku attributes and availability info */
export const CartItemAttributes = ({
  item,
  className,
}: {
  item: CartItemType;
  className?: string;
}): JSX.Element => {
  if (!isDigitalGreetingCard(item)) {
    const availability = item.availability || {};
    const itemAttributes = item.attributes || [];
    return (
      <div className={cx(styles.cartItemAttributes, className)} data-testid="cart-item-attribute">
        {itemAttributes?.map((skuAttribute) => (
          <div key={skuAttribute.label}>
            <span>
              <span className={styles.label} data-testid="cart-item-attribute-label">
                {skuAttribute.label}:
              </span>{' '}
              <span className={styles.value} data-testid="cart-item-attribute-value">
                {skuAttribute.value}
              </span>
            </span>
          </div>
        ))}
        {availability.stockStatus && (
          <div>
            <span className={styles.label} data-testid="cart-item-attribute-label">
              Availability:
            </span>{' '}
            <span className={styles.value} data-testid="cart-item-attribute-value">
              {availability.stockStatus}
            </span>
          </div>
        )}
        {availability.arrivalRange && (
          <div>
            <span className={styles.label} data-testid="cart-item-attribute-label">
              Estimated arrival:
            </span>{' '}
            <span data-testid="cart-item-attribute-value">
              <DateRange
                className={cx(styles.value, styles.noTextTransform)}
                dateRange={availability.arrivalRange}
              />
            </span>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className={styles.cartItemAttributes} data-testid="cart-item-attribute">
      <div>
        <span>Choose a design and add your message at checkout.</span>
      </div>
    </div>
  );
};
